import type { CustomPopperProps } from '@wix/thunderbolt-elements/src/providers/usePopper/usePopper';

import { calculateOffset } from './offset';

type GetPopperConfigOptions = {
  rootElement: HTMLDivElement | null;
  referenceElement: HTMLDivElement | null;
};

export const getPopperConfig = ({
  rootElement,
  referenceElement,
}: GetPopperConfigOptions) => {
  if (!rootElement || !referenceElement) {
    return;
  }

  // in Classic editor, preview iframe on mobile is actually desktop width,
  // causing calculation inaccuracies
  // TODO: this shouldn't be needed, need to raise question to Editor Platform
  const boundaryElement =
    document.getElementById('SITE_CONTAINER') || document.body;

  return {
    placement: 'bottom-start',
    strategy: 'absolute',
    modifiers: [
      {
        name: 'flip',
        options: {
          boundary: 'clippingParents',
          fallbackPlacements: ['top-start', 'bottom-start'],
          allowedAutoPlacements: ['top-start', 'bottom-start'],
        },
      },
      {
        name: 'computeStyles',
        options: {
          adaptive: false,
        },
      },
      {
        name: 'offset',
        options: {
          offset: ({ placement, popper }) =>
            calculateOffset({
              popper,
              placement,
              rootElement,
              referenceElement,
              boundaryElement,
            }),
        },
      },
    ],
  } as CustomPopperProps;
};
